<template>
  <div>
    <CPageTitle
      :label="$t('measurePageTitle')"
      :subLabel="$t('measurePageSubTitle')"
      :withButton="allowExport"
      :buttonLabel="$t('export')"
      @ButtonRightClicked="handleButtonRightClicked"
    ></CPageTitle>

    <div class="row">
      <div class="col-8">
        <CMainMeasures
          :seats="seats"
          :algoSelected="algoSelected"
          :algoList="algoList"
          :layerColors="layerColors"
          :layerSelected="layerSelected"
          :maxNbPoints="maxNbPoints"
          :contextualHelp="contextualHelp"
          :doExport="doExport"
          @CustomLayer="handleAlgoChanged"
          @NbPointsChanged="handleNbPointsChanged"
          @ContextualHelpChanged="handleContextualHelpChanged"
          @AllowExport="handleAllowExport"
        ></CMainMeasures>
      </div>
      
      <div class="col-4">
        <CSettings 
          :seats="seats"
          :forceUpdate="forceUpdate"
          :algoSelected="algoSelected"
          :algoList="algoList"
          :layerColors="layerColors"
          :layerSelected="layerSelected"
          :nbPoints="nbPoints"
          :maxNbPoints="maxNbPoints"
          @NbSeatsChanged="handleNbSeatsChanged"
          @NewRow="handleNewRow"
          @AlgoChanged="handleAlgoChanged"
          @LayerChanged="handleLayerChanged"
          @MaxPointChanged="handleMaxPointChanged"
          @ContextualHelpChanged="handleContextualHelpChanged"
        ></CSettings>
      </div>
    </div>
  </div>
</template>

<script>
import CPageTitle from "@/lib/tui/components/titles/CPageTitle.vue";
import CMainMeasures from "@/components/measures/CMainMeasures.vue";
import CSettings from "@/components/measures/CSettings.vue";

export default {
  name: "VMeasures",
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  components: {
    CPageTitle,
    CMainMeasures,
    CSettings
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  data () {
    return {
      seats: [
        1, 2
      ],
      forceUpdate: false,
      layerSelected: 0,
      layerColors: [
        { id: -2, color: "#93C24C" },
        { id: -1, color: "transparent" },
        { id: 0, color: "#008AC5" },
        { id: 1, color: "#2DE5FE" }
      ],
      algoList: [
        { id: "algo1", label: this.$t('algo1Title') },
        { id: "algo2", label: this.$t('algo2Title') },
      ],
      algoSelected: "algo1",
      nbPoints: 0,
      maxNbPoints: 25,
      contextualHelp: "algo",
      doExport: false,
      allowExport: true
    }
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  methods: {
    handleNbSeatsChanged: function(event) {
      if (event.value === 0)
        this.seats.pop();
      else {
        this.seats[event.row] = event.value;
      }

      this.forceUpdate = !this.forceUpdate;
    },
    ///////////////////////////////////////////////////////////////
    handleNewRow: function() {
      this.seats.push(1);
    },
    ///////////////////////////////////////////////////////////////
    handleAllowExport: function(event) {
      this.allowExport = event;
    },
    ///////////////////////////////////////////////////////////////
    handleAlgoChanged: function(event) {
      this.algoSelected = event;

      if (this.algoSelected !== "custom") {
        this.layerSelected = 0;
      }
    },
    ///////////////////////////////////////////////////////////////
    handleLayerChanged: function(event) {
      this.layerSelected = event.id;
    },
    ///////////////////////////////////////////////////////////////
    handleNbPointsChanged: function(nbPoints) {
      this.nbPoints = nbPoints;
    },
    ///////////////////////////////////////////////////////////////
    handleMaxPointChanged: function(event) {
      this.maxNbPoints = event;
    },
    ///////////////////////////////////////////////////////////////
    handleContextualHelpChanged: function(event) {
      this.contextualHelp = event;
    },
    ///////////////////////////////////////////////////////////////
    handleButtonRightClicked: function() {
      this.doExport = !this.doExport;
    }
  }
}
</script>